import ClubFeeCategory from './ClubFeeCategory.js';

export default class ClubSalesListOfferingConfig {
    static fromData(data) {
        if (!data) {
            return;
        }

        const offeringConfig = new ClubSalesListOfferingConfig();
        offeringConfig.id = data.id;
        offeringConfig.clubFeeCategories = data.clubFeeCategories.map(
            (categoryData) => ClubFeeCategory.fromData(categoryData),
        );

        return offeringConfig;
    }

    serialize() {
        return {
            id: this.id,
            clubFeeCategories: this.clubFeeCategories.map((category) => category.id),
        };
    }
}
